import { MedrecordMoment } from '@medrecord/services-datetime';
import { ResourceType } from '../enums/resource-type.enum';
import { ResourceBlockFunction } from '../interfaces/resource-block-function.interface';

export const plannedCareActivityAppointmentBlock: ResourceBlockFunction = () => ({
  resourceType: ResourceType.appointment,
  fieldGroups: [
    {
      name: ({ resource }) => resource.content?.contactSubject || 'my_doctor_appointment',
      fields: [
        {
          label: 'my_doctor_status',
          fieldName: 'status',
          prepareData: (data) => data?.coding?.[0]?.display,
        },
        {
          label: 'my_doctor_start_date',
          fieldName: 'period',
          prepareData: (data) => (data?.start ? MedrecordMoment(data?.start).format('LLL') : ''),
        },
        {
          label: 'my_doctor_end_date',
          fieldName: 'period',
          prepareData: (data) => (data?.end ? MedrecordMoment(data?.end).format('LLL') : ''),
        },
        {
          label: 'my_doctor_comment',
          fieldName: 'comment',
          prepareData: (data) => data,
        },
        {
          label: 'my_doctor_type',
          fieldName: 'appointmentType',
          prepareData: (data) => data?.coding?.[0]?.display,
        },
        {
          label: 'my_doctor_care_provider',
          fieldName: 'practitioner',
          prepareData: (data) => data?.display,
        },
        {
          label: 'my_doctor_organization_name',
          fieldName: 'organizationLocation',
          prepareData: (data) => data?.display,
        },
      ],
    },
  ],
});
